export default "__VITE_ASSET__CwnB3xyp__"